

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { getImgUrl } from '../utils/dummy';
import { HOST } from '@/global';

import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

@Component({
  name: 'Pagebanner'
})
export default class PageBanner extends Vue {
  @Prop() private title!: string;
  @Prop() private imgSrc!: any;
  HOST: string = HOST;
  // @Prop() pageData: any;

  pageLoadTl() {
    const pageTl = new TimelineMax({ delay: 1.1 });

    pageTl.fromTo(
      '.slide-img',
      1,
      { height: 0 },
      { height: '100%', ease: Expo.easeInOut, clearProps: 'all' }
    );
  }

  public mounted() {
    // this.pageLoadTl();
  }
}
